import {
    MenuWrapper,
    MenuList,
    MenuItem
} from './style'
import Button from '../generalButton/index.jsx';

export default (props) => {
    const { changeScreen, triggerOptions } = props;

    return (
        <MenuWrapper>
            <MenuList>
                <MenuItem>
                    <Button 
                        txt={window.rs ? 'Nova Igra' : 'New Game'} 
                        buttonAction={() => {
                            changeScreen('GameplayScreen')
                        }}
                        leftGradiant={'rgb(65, 105, 225)'}
                        rightGradiant={'rgb(135, 206, 235)'}
                        triangleHeight={'50px'}
                        markerHeight={'50px'}
                        sizeFont={'1.55rem'}
                        markerDeg={'27deg'}
                    />
                </MenuItem>
                <MenuItem>
                    <Button 
                        txt={window.rs ? 'Preference' : 'Preferences'} 
                        buttonAction={() => {
                            triggerOptions(true)
                        }}
                        leftGradiant={'rgb(65, 105, 225)'}
                        rightGradiant={'rgb(135, 206, 235)'}
                        triangleHeight={'50px'}
                        markerHeight={'50px'}
                        sizeFont={'1.55rem'}
                        markerDeg={'27deg'}
                    />
                </MenuItem>
                <MenuItem>
                    <Button 
                        txt={window.rs ? 'Izađi' : 'Exit Game'}
                        leftGradiant={'rgb(65, 105, 225)'}
                        rightGradiant={'rgb(135, 206, 235)'}
                        triangleHeight={'50px'}
                        markerHeight={'50px'}
                        sizeFont={'1.55rem'}
                        markerDeg={'27deg'}
                        buttonAction={() => {
                            window.open("about:blank", "_self");
                            window.close();
                        }}
                    />
                </MenuItem>
            </MenuList>
        </MenuWrapper>
    )
}